import FormMessageHandler from '../components/formMessageHandler';
import Recaptcha from '../components/recaptcha';
import {cacoo} from "../components/cacoo";

if ($("body").hasClass("page--contact")) {
  let Spinner = require('spin');
  let swfobject = require('swfobject');
  let cacoo = require('../components/cacoo').cacoo;

  class Contact {
    constructor() {
      this.form = $('form#contactForm');
      this.name = $('input[name="name"]', this.form);
      this.email = $('input[name="email"]', this.form);
      this.message = $('textarea[name="messages"]', this.form);
      this.submitButton = $('button[type="button"]', this.form);
      this.tos = $('input#privacyAgree', this.form);
      this.tosError = $('#agreeError', this.form);
      this.recaptchaToken = $('input[name="recaptchaToken"]', this.form);
      this.recaptchaError = $('.error-message.recaptcha', this.form);
      this.subject = $('select[name="subject"]', this.form);
      this.successOverlay = $('.contact_success__overlay');
      this.successMessage = $('.contact__success');
      this.formMessageHandler = new FormMessageHandler(this.form);
      this.fileUploader = $('input[name="attachedFile"]', this.form)[0];
      this.fileLabel = $('.attachment-upload__label', this.form);
      this.recaptcha = new Recaptcha(this.recaptchaToken);

      this.flash = $('input[name="flash"]', this.form);
      this.java = $('input[name="java"]', this.form);

      this.recaptchaError.html(Cacoo.SiteResources.recaptcha_error);

      this.openChatLink = $('.js_open-chat-link');

      // Get java and flash version
      let flashStr = swfobject.getFlashPlayerVersion().major + "." + swfobject.getFlashPlayerVersion().minor + "." + swfobject.getFlashPlayerVersion().release;
      let javaStr = navigator.javaEnabled();

      if (flashStr.length > 0) {
        this.flash.val(flashStr);
      } else {
        this.flash.val("DISABLED");
      }
      if (javaStr.length > 0) {
        this.java.val(javaStr.toLowerCase() == "true" ? "ENABLED" : "DISABLED");
      } else {
        this.java.val("DISABLED");
      }

      this.buttonSpinner = new Spinner({ color: '#fff', lines: 12 });

      this.attachEvent();
    }

    attachEvent() {
      this.submitButton.on('click', () => {
        if (this.checkFields()) {
          this.submit();
        }
        return false;
      });

      this.email.on('focusout', () => {
        this.checkEmailFormat();
      });

      this.name.on('focusout', () => {
        this.checkName();
      });

      this.message.on('focusout', () => {
        this.checkMessage();
      });

      this.subject.on("change", () => {
        this.checkSubject();
      });

      this.tos.on('change', () => {
        this.tosError.hide();
      });

      if (typeof window.Intercom !== "undefined") {
        this.openChatLink.on('click', (e) => {
          e.preventDefault();
          Intercom('showNewMessage');
        });
      }

      // console.error(this.fileUploader);
      $(this.fileUploader).change((e) => {
        let file = e.target.files[0];
        if(file) {
          this.fileLabel.html(`<i class="icon icon-attachment"></i>${file.name}`);
        }
      });
    }

    checkEmailFormat() {
      if (!cacoo.util.validateEmail(this.email.val())) {
        this.formMessageHandler.showError('email', Cacoo.SiteResources['modal_signup_email_error']);
        return false;
      }
      this.formMessageHandler.showSuccess('email');
      return true;
    }

    checkName() {
      if (this.name.val().length < 1) {
        this.formMessageHandler.showError("name", Cacoo.SiteResources["modal_signup_name_error"]);
        return false;
      }

      if (cacoo.util.validateEmail(this.name.val()) || cacoo.util.isUrlString(this.name.val())) {
        this.formMessageHandler.showError('name', Cacoo.SiteResources['modal_signup_name_error']);
        return false;
      }
      this.formMessageHandler.showSuccess("name", true);
      return true;
    }

    checkMessage() {
      if (this.message.val().length < 10 || this.message.val().length > 10000) {
        this.formMessageHandler.showError("messages", Cacoo.SiteResources["contact_field_error_length"]);
        return false;
      }
      this.formMessageHandler.showSuccess("messages", true);
      return true;
    }

    checkSubject() {
      if ($("option:selected", this.subject).val() == "") {
        this.formMessageHandler.showError("subject", Cacoo.SiteResources["contact_subject_error"]);
        return false;
      }
      this.formMessageHandler.showSuccess("subject", true);
      return true;
    }

    checkTos() {
      if (this.tos.length > 0 && !this.tos.is(":checked")) {
        this.tosError.show();
        return false;
      }

      return true;
    }

    checkFields() {
      this.checkEmailFormat();
      this.checkName();
      this.checkMessage();
      this.checkSubject();
      this.checkTos();

      if (this.email.hasClass("is_error") ||
        this.name.hasClass("is_error") ||
        this.message.hasClass("is_error") ||
        this.subject.hasClass("is_error") ||
        this.tos.length > 0 && !this.tos.is(":checked")) {
        return false
      }

      return true;
    }

    getData() {
      let formData = new FormData();
      formData.append("name", this.name.val());
      formData.append("email", this.email.val());
      formData.append("comment", this.message.val());
      formData.append("flash", this.flash.val());
      formData.append("java", this.java.val());
      formData.append("subject", this.subject.val());
      formData.append("recaptchaToken", this.recaptchaToken.val());

      let file = this.fileUploader.files[0];
      if (file) {
        formData.append('attachedFile', file, file.name);
      }

      return formData;
    }

    submit() {
      if (this.submitButton.hasClass('disable')) {
        return false;
      }
      this.recaptcha.check().then(() => {
        this.startButtonSpinner();
        cacoo.ajax({
          url: this.form.attr('action'),
          method: "POST",
          data: this.getData(),
          dataType: 'json',
          processData: false, // Don't process the files
          contentType: false, // Set content type to false as jQuery will tell the server its a query string request
          success: () => {
            this.submitForm_load();
          },
          error: (err) => {
            this.stopButtonSpinner();
            this.recaptcha.reset();

            if (!err.errors) {
              this.formMessageHandler.showError("default", Cacoo.SiteResources.modal_signup_default_error);
            } else {
              this.formMessageHandler.showError(err.errors.field, err.errors.message);
            }
            return false;
          }
        });
      }, () => {
        this.recaptcha.reset();
        this.stopButtonSpinner();
      });

    }

    submitForm_load() {
      this.stopButtonSpinner();
      this.successMessage.html(Cacoo.SiteResources["contact_mail_complete"]);

      $.Velocity.animate(this.successOverlay, {
        opacity: .9
      }, {
        visibility: "visible"
      });

      $.Velocity.animate(this.successMessage, {
        opacity: 1
      }, {
        visibility: "visible"
      });
    }


    startButtonSpinner() {
      this.submitButton.addClass('disable');
      this.buttonSpinner.spin(this.submitButton.get(0));
    };

    stopButtonSpinner() {
      this.submitButton.removeClass('disable');
      this.buttonSpinner.stop();
    };

  }

  new Contact();
}
